jQuery(".menu-icon").click( function() {
    jQuery("body").addClass("open-menu");
})

jQuery(".close-icon").click( function() {
    jQuery("body").removeClass("open-menu");
})